import { Pencil, Trash } from 'lucide-react'

export const SCHEDULE_FAB = [
  {
    id: '5',
    icon: Trash,
    type: 'delete',
    excludeStatus: ['9', '8', '4', '1'],
    label: 'Deletar pedido',
  },
  {
    id: '6',
    icon: Pencil,
    type: 'edit',
    excludeStatus: ['9', '4', '8', '1'],
    label: 'Editar pedido',
  },
]
